import React from 'react';

import { useTranslation } from 'react-i18next';

const ToolGrid = ({ onToolSelect }) => {
  const { t } = useTranslation();
  const tools = [
    { id: 'merge', icon: 'fas fa-file-import', title: t('app.merge'), description: t('app.descMerge') },
    { id: 'split', icon: 'fas fa-file-export', title: t('app.split'), description: t('app.descSplit') },
    { id: 'rotate', icon: 'fas fa-sync-alt', title: t('app.rotate'), description: t('app.descRotate') },
    { id: 'extract-text', icon: 'fas fa-file-alt', title: t('app.extractText'), description: t('app.descExtractText') },
    { id: 'watermark', icon: 'fas fa-stamp', title: t('app.watermark'), description: t('app.descWatermark') },
    { id: 'pageNumbers', icon: 'fas fa-list-ol', title: t('app.pageNumbers'), description: t('app.descPageNumbers') },
    
    { id: 'more-soon', icon: 'fas fa-plus-circle', title: t('app.moreFunctionsSoon'), description: t('app.descMoreFunctionsSoon'), disabled: true },
  ];

  return (
    <div className="tool-grid-container">
      <div className="tool-grid">
        {tools.map(tool => (
          <div key={tool.id} className={`tool-card ${tool.disabled ? 'disabled' : ''}`} onClick={() => !tool.disabled && onToolSelect(tool.id)} role="button" tabIndex={tool.disabled ? -1 : 0} onKeyPress={(e) => !tool.disabled && e.key === 'Enter' && onToolSelect(tool.id)}>
            <i className={tool.icon}></i>
            <h3>{tool.title}</h3>
            <p>{tool.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToolGrid;